import { useQuery } from 'react-query';
import { DEFAULT_PAGE } from '../components/BreadcrumbsDropdown/pickerConstatns';

const CACHE_TIME = 30 * 1000;

export const usePickerTotal = ({ fetcher, enabled, queryKey }) => {
    const { isSuccess, data } = useQuery(
        queryKey,
        async () => {
            const { total } = await fetcher({
                searchText: '',
                pageSize: 1,
                isRetry: false,
                queryKey,
                page: DEFAULT_PAGE,
            });
            return total;
        },
        { enabled, cacheTime: CACHE_TIME, staleTime: CACHE_TIME }
    );

    const total = enabled && isSuccess ? data : null;

    return total;
};
